import isBrowser from './isBrowser';

/**
 * get host for internal requests
 */
export const getHost = () => {
  const host = isBrowser() ? location.origin : process.env.ENTERPRISE_HOST_INTERNAL;
  return host;
};
